import { SettingsField } from '../SettingsField'

import * as styles from './SettingsCompactField.module.css'

function SettingsCompactField({
  fieldInputClassName = styles.fieldInput,
  ...restProps
}) {
  return (
    <SettingsField {...restProps} fieldInputClassName={fieldInputClassName} />
  )
}

export default SettingsCompactField
